<template>
  <div :class="['backdrop', props.fixed && 'backdrop-fixed']">
    <slot />
  </div>
</template>

<script setup lang="ts">
type Props = {
  /** Covers the viewport rather than the nearest positioned ancestor. */
  fixed?: boolean;
};

const props = defineProps<Props>();
</script>

<style scoped>
@reference "../../../assets/css/main.css";

.backdrop {
  @apply absolute w-full h-full inset-0 z-50 cursor-default flex items-center justify-center;
  background: rgba(0, 0, 0, 0.2);
}

.backdrop-fixed {
  @apply fixed z-modal;
}
</style>
